const audience = [
  {
    label: "For talent acquisition teams",
    title: "Shortlists faster than a typical agency search",
    description:
      "Send us a req the same way you'd brief an agency. Our platform returns a ranked shortlist in hours, not the days a manual search usually takes.",
  },
  {
    label: "For fast-scaling companies",
    title: "Hire faster without a bigger recruiting roster",
    description:
      "Adding more recruiters to your account doesn't help if each one is still searching by hand. Our platform scales past manual search without adding headcount on either side.",
  },
  {
    label: "For hard-to-fill roles",
    title: "A corpus deep enough to find who manual searches miss",
    description:
      "5M+ profiles, refreshed monthly, matched by context rather than keywords — built for the roles that sit open longest when searched by hand.",
  },
];

export const AudienceSection = () => {
  return (
    <section className="qh-audience">
      <div className="qh-wrap">

        <div className="qh-section-head">
          <span className="qh-tag">
            // Built for teams evaluating recruiting options
          </span>

          <h2>Made for companies who need to hire faster than an agency can.</h2>

          <p>
            Whether you were about to brief an agency or post the role yourself,
            QuantumHire&apos;s platform gets you a ranked shortlist before either
            approach has even ramped up — powered by an AI engine, backed by real
            recruiters.
          </p>
        </div>
      </div>

      <div className="qh-aud-grid">
        {audience.map((item) => (
          <div className="qh-aud-card" key={item.label}>
            <span className="qh-mono">{item.label}</span>

            <h3>{item.title}</h3>

            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
